"use strict"

const angular = require("angular");

angular
    .module("Agnes")
    .factory("$activity", [
        "$rootScope",
        function ($rootScope) {
            $rootScope.activity = 0;

            var $activity = {};
            $activity.start = function () {
                $rootScope.activity++;
            };
            $activity.finish = function () {
                $rootScope.activity--;
            };

            return $activity;
        }
    ]);